import { Service, ServiceCategory } from '@/types/services';
import { serviceReduxConstants } from '@/constants';

function setServices({ ids, all }: { ids: Array<number>; all: { [id: number]: Service } }) {
  return { type: serviceReduxConstants.SET_SERVICES, payload: { ids, all } };
}

function setServiceCategories({ ids, all }: { ids: Array<number>; all: { [id: number]: ServiceCategory } }) {
  return { type: serviceReduxConstants.SET_SERVICE_CATEGORIES, payload: { ids, all } };
}

export const serviceActions = {
  setServices,
  setServiceCategories,
};
